import { EnvelopeSimpleIcon as PhosphorEnvelopeSimpleIcon } from "@phosphor-icons/react/dist/ssr/EnvelopeSimple";

import { createAppIcon } from "@/components/createAppIcon";

export const MailIcon = /* @__PURE__ */ createAppIcon(PhosphorEnvelopeSimpleIcon);
export const UnreadEmailIcon = /* @__PURE__ */ createAppIcon(PhosphorEnvelopeSimpleIcon);
